import { useContext, useRouter } from '@nuxtjs/composition-api'
import { AxiosError } from 'axios'
import JapanPostalCode from 'japan-postal-code'
import useCookies from '~/composables/useCookies'
import useFlashMessage from '~/composables/useFlashMessage'

type TwitterAuthorizeResponse = {
  token: string
  secret: string
  // eslint-disable-next-line camelcase
  authorize_url: string
}

type OAuth2AuthorizeResponse = {
  // eslint-disable-next-line camelcase
  authorize_url: string
}

export default () => {
  const { $auth, $axios } = useContext()
  const $router = useRouter()
  const $cookies = useCookies()
  const { showFlashNoticeMessage, showFlashAlertMessage } = useFlashMessage()

  const loginWithPassword = async (
    emailOrUsername: string,
    password: string
  ) => {
    try {
      await $auth.loginWith('local', {
        data: {
          email_or_username: emailOrUsername,
          password
        }
      })

      // アカウント凍結チェック
      if ($auth.user!.lock_reason) {
        $auth.logout()
        showFlashAlertMessage('このアカウントは現在凍結されています。')
        return false
      }

      showFlashNoticeMessage('ログインしました。')

      const afterLoginURL = $cookies.get('afterLoginURL') || '/'
      $cookies.remove('afterLoginURL')
      $router.push(afterLoginURL)

      return true
    } catch (e) {
      const { response } = e as AxiosError<CommonErrorResponse>
      showFlashAlertMessage(response!.data.error_message)
      return false
    }
  }

  const loginWithTwitter = async () => {
    try {
      const data = await $axios.$get<TwitterAuthorizeResponse>(
        '/auth/twitter_authorize_url',
        {
          params: {
            callback_url: `${location.protocol}//${location.host}/users/auth/twitter/callback`
          }
        }
      )

      location.href = data.authorize_url
    } catch {
      alert('現在、X(Twitter)ログインはご利用いただけません。')
    }
  }

  const loginWithFacebook = async () => {
    try {
      const data = await $axios.$get<OAuth2AuthorizeResponse>(
        '/auth/facebook_authorize_url',
        {
          params: {
            callback_url: `${location.protocol}//${location.host}/users/auth/facebook/callback`
          }
        }
      )

      location.href = data.authorize_url
    } catch {
      alert('現在、Facebookログインはご利用いただけません。')
    }
  }

  const loginWithGoogle = async () => {
    try {
      const data = await $axios.$get<OAuth2AuthorizeResponse>(
        '/auth/google_authorize_url',
        {
          params: {
            callback_url: `${location.protocol}//${location.host}/users/auth/google_oauth2/callback`
          }
        }
      )

      location.href = data.authorize_url
    } catch {
      alert('現在、Facebookログインはご利用いただけません。')
    }
  }

  return {
    loginWithPassword,
    loginWithTwitter,
    loginWithFacebook,
    loginWithGoogle
  }
}
